import React from "react";
import { IClientData } from "../../../../Models/ApiModels";
import {
  CostTable,
  CostTableContainer,
  CostTableTbody,
  CostTableTd,
  CostTableTh,
  CostTableThead,
  CostTableTr,
} from "./styled";

interface IUserCostsTableProps {
  userInfo: IClientData;
}

const UserCostsTable: React.FC<IUserCostsTableProps> = ({ userInfo }) => {
  return (
    <CostTableContainer>
      <CostTable>
        <CostTableThead>
          <CostTableTr>
            <CostTableTh>Store</CostTableTh>
            <CostTableTh>Install, $</CostTableTh>
            <CostTableTh>Rate, $</CostTableTh>
            <CostTableTh>Review, $</CostTableTh>
            <CostTableTh>Impressions, $</CostTableTh>
          </CostTableTr>
        </CostTableThead>
        <CostTableTbody>
          <CostTableTr>
            <CostTableTd>Google play</CostTableTd>
            <CostTableTd>{userInfo.install_cost}</CostTableTd>
            <CostTableTd>{userInfo.rate_cost}</CostTableTd>
            <CostTableTd>{userInfo.review_cost}</CostTableTd>
            <CostTableTd>—</CostTableTd>
          </CostTableTr>
          <CostTableTr>
            <CostTableTd>App Store</CostTableTd>
            <CostTableTd>{userInfo.a_install_cost}</CostTableTd>
            <CostTableTd>{userInfo.a_rate_cost}</CostTableTd>
            <CostTableTd>{userInfo.a_review_cost}</CostTableTd>
            <CostTableTd>{userInfo.a_view_cost}</CostTableTd>
          </CostTableTr>
        </CostTableTbody>
      </CostTable>
    </CostTableContainer>
  );
};

export default UserCostsTable;
